export default __webpack_public_path__ + "static/media/roleta.c63c0908.jpeg";